import { render, staticRenderFns } from "./AppDisplayTemplateBoolean.vue?vue&type=template&id=424a99cf&"
import script from "./AppDisplayTemplateBoolean.vue?vue&type=script&lang=js&"
export * from "./AppDisplayTemplateBoolean.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports